const TYPES = ({

  // list
  loadingFormSearch: 'LOADING_SEARCH_SETTINGS_AMENDMENT_STAGE_FORM_TOGGLE',
  searchSuccess: 'SEARCH_SETTINGS_AMENDMENT_STAGE_SUCCESS',
  searchError: 'SEARCH_SETTINGS_AMENDMENT_STAGE_LIST_ERROR',

  // form create
  updateList: 'UPDATE_LIST_SETTINGS_AMENDMENT_STAGE',
  insertList: 'INSERT_LIST_SETTINGS_AMENDMENT_STAGE',
  deleteList: 'DELETE_LIST_SETTINGS_AMENDMENT_STAGE',

  // form search
  setDefaultPage: 'SET_SEARCH_SETTINGS_AMENDMENT_STAGE_DEFAULT_PAGE',
});

export default TYPES;
